import { on } from 'delegated-events'
import Swiper from 'swiper'
import { Autoplay, EffectFade } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/effect-fade'

Swiper.use([Autoplay, EffectFade])

document.querySelectorAll('.element-claimtypes').forEach((el) => {
  const container = el.querySelector('.claim-types-slider')
  const numSlides = container.querySelectorAll('.swiper-slide').length
  const list = el.querySelector('.claim-types-list')

  if (numSlides > 1) {
    const swiper = new Swiper(container.querySelector('.swiper'), {
      slidesPerView: 1,
      speed: 1000,
      effect: 'fade',
      simulateTouch: false,
      preloadImages: false,
      fadeEffect: {
        crossFade: true,
      },
      preloadImages: false,
      loop: true,
      loopedSlides: numSlides,
      autoplay: {
        delay: 4000,
      },
      on: {
        activeIndexChange: (swiper) => {
          const newIndex = swiper.realIndex

          list.querySelectorAll('li.is-active').forEach((x) => x.classList.remove('is-active'))
          list.querySelector(`[data-index="${newIndex + 1}"]`).classList.add('is-active')
        },
      },
    })

    on('mouseover', '.claim-types-list .claim-type-item', (e) => {
      const item = e.target.closest('li')
      const index = item.dataset.index - 1
      swiper.autoplay.stop()
      swiper.slideTo(index)
    })

    on('mouseout', '.claim-types-list .claim-type-item', () => {
      swiper.autoplay.start()
    })
  }
})
